import { SERVER_URL } from '@/constants/constants';
import { signRequestPayload } from '@/helper/encrypt';
import { IGameAnalyticInput } from '@/interface/gameAnalytics';

export const sendGameEventBeaconAction = (value: IGameAnalyticInput) => {
  const sign = signRequestPayload(value);
  const url = SERVER_URL;
  const data: any = {
    operationName: 'createGameAnalytic',
    variables: {
      input: {
        sign,
      },
    },
    query:
      'mutation createGameAnalytic($input: SignPayloadInput!) {\n  createGameAnalytic(input: $input) {\n    game\n  }\n}',
  };

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    keepalive: true,
  });
};
